import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-integrations',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './integrations.component.html',
  styleUrl: './integrations.component.css'
})
export class IntegrationsComponent {
  hardwareBrands = ['Cisco', 'Yealink', 'Grandstream', 'Polycom'];
  softwareBrands = ['Salesforce', 'Zendesk', 'HubSpot', 'MS Teams'];
}
